var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfinityOptimized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.275 0c-2.46 0-4.783.989-6.44 2.702L13.825 13.72a5.654 5.654 0 0 1-4.1 1.748c-3.195 0-5.808-2.666-5.808-5.968S6.53 3.532 9.725 3.532c1.555 0 3.007.618 4.168 1.818l1.93 1.766 2.614-2.366-2.186-1.96A9.16 9.16 0 0 0 13.258.72 8.915 8.915 0 0 0 9.725 0C4.635 0 .5 4.273.5 9.5S4.634 19 9.725 19c2.46 0 4.783-.989 6.44-2.702L28.175 5.28a5.654 5.654 0 0 1 4.1-1.748c3.195 0 5.808 2.666 5.808 5.968s-2.613 5.968-5.808 5.968c-1.537 0-3.007-.618-4.168-1.818l-1.982-1.784-2.563 2.366 2.187 1.978a9.185 9.185 0 0 0 2.996 2.058c1.12.476 2.32.719 3.53.714 5.09 0 9.225-4.255 9.225-9.482 0-5.297-4.134-9.5-9.225-9.5Z",
    fill: "#02E4C0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinityOptimized);
export default __webpack_public_path__ + "static/media/infinity-optimized.0425cb919c5967df1570d070ebe75990.svg";
export { ForwardRef as ReactComponent };